/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared';
import { IGetSeoUrlsFromQueryStringsResponseSchema } from '../../entities/schemas/GetSeoUrlsFromQueryStringsResponseSchema';

export type TSeourlsGetSeoUrlsFromQueryStringsModel = IModel<
  ISeourlsGetSeoUrlsFromQueryStringsRequest,
  TSeourlsGetSeoUrlsFromQueryStringsResponse
>;

export interface ISeourlsGetSeoUrlsFromQueryStringsRequest {
  /** Список query strings **/
  queryStrings: string[];
}

export type TSeourlsGetSeoUrlsFromQueryStringsResponse =
  | ISeourlsGetSeoUrlsFromQueryStringsResponse200
  | ISeourlsGetSeoUrlsFromQueryStringsResponse400;

export interface ISeourlsGetSeoUrlsFromQueryStringsResponse200
  extends IModelResponse<ISeourlsGetSeoUrlsFromQueryStringsResponse> {
  statusCode: 200;
}

export interface ISeourlsGetSeoUrlsFromQueryStringsResponse400
  extends IModelResponse<ISeourlsGetSeoUrlsFromQueryStringsResponseError> {
  statusCode: 400;
}

export interface ISeourlsGetSeoUrlsFromQueryStringsResponse {
  data: IGetSeoUrlsFromQueryStringsResponseSchema;
  status: EStatus;
}

export interface ISeourlsGetSeoUrlsFromQueryStringsResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISeourlsGetSeoUrlsFromQueryStringsResponse | ISeourlsGetSeoUrlsFromQueryStringsResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISeourlsGetSeoUrlsFromQueryStringsResponse): TResponse200;
  400(response: ISeourlsGetSeoUrlsFromQueryStringsResponseError): TResponse400;
}
